<template>
  <div>
    <div class="d-flex justify-content-end ">

      <v-btn class="btn-buy rounded-lg " @click.stop.prevent="settingBuy" >
      <v-icon class="mx-2">mdi-cog-clockwise</v-icon>
        تنظیمات ارسال از فروشنده
      </v-btn>
    </div>
    <seller-shipping-settings :showTuts="showSetting"/>
    
    <!-- جدول اصلی: لیست خریداران -->
    <vue-table
      :data="tableData"
      :headers="buyerHeaders"
      :loading="loading"
      @change="onPagination"
    >
            <template v-slot:filters="{ props, perPage }">
                <v-row no-gutters class="my-4">
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.length"
                      :items="perPage"
                      class="rounded-lg"
                      dense
                      hide-details
                      :label="$t('qrUsersList.perPage')"
                      outlined
                      @change="() => onPagination(props)"
                    />
                  </v-col>      
                  <v-col class="pa-2" cols="12" lg="3" md="3">
                    <v-text-field
                      v-model="props.search"
                      append-icon="mdi-magnify"
                      label="جستجو ..."
                      outlined
                      dense
                      hide-details
                      clearable
                      class="rounded-lg"
                      @keyup.enter="() => onPagination(props)"
                      @click:clear="() => { props.search = null; onPagination(props); }"
                    />
                  </v-col>
                </v-row>
              </template>

      <template v-slot:index="{item}">
         {{ persian(item.index + 1 + ((tableData.current_page || 1) - 1) * (tableData.per_page || 10)) }}
      </template>

      <template v-slot:location="{ item }">
        <span v-if="item.state && item.state !== '-' && item.city && item.city !== '-'">
          {{ item.state }} - {{ item.city }}
        </span>
        <span v-else>نامشخص</span>
      </template>
      
      <template v-slot:orders_count="{ item }">
        <v-chip v-if="item.orders_count" small color="primary" outlined class="font-weight-bold">
          {{ persian(item.orders_count) }} سفارش
        </v-chip>
        <span v-else class="grey--text">---</span>
      </template>

      <!-- دکمه‌های عملیات خریدار (جزئیات / سفارشات) -->
      <template v-slot:action="{ item }">
        <action-buttons :data="item" :meta="buyerMetabutton" />
      </template>
    </vue-table>

    <!-- پاپ‌آپ ۱: جزییات کامل خریدار (طراحی مدرن) -->
    <custom-popup
      v-model="popups.details"
      :cons="{ title: 'پروفایل و جزییات خریدار' }"
      max-width="650"
      :reloadable="false"
    >
      <v-card class="pa-3 rounded-xl" flat color="transparent">
        <!-- لودینگ -->
        <div v-if="detailsLoading" class="d-flex flex-column align-center justify-center py-12">
          <v-progress-circular indeterminate color="primary" size="64" width="4"></v-progress-circular>
          <span class="mt-4 grey--text text-subtitle-1">در حال دریافت اطلاعات...</span>
        </div>
        
        <!-- اطلاعات -->
        <div v-else-if="selectedBuyerDetails">
          
          <!-- هدر پروفایل با گرادیان -->
          <v-card class="mb-5 rounded-xl d-flex align-center pa-5 info-header-gradient" elevation="3">
            <v-avatar size="64" color="white" class="ml-4 elevation-2">
              <v-icon size="36" color="primary">mdi-account-outline</v-icon>
            </v-avatar>
            <div>
              <div class="text-h5 font-weight-black white--text mb-1">
                {{ selectedBuyerDetails.name || 'کاربر بدون نام' }}
              </div>
              <div class="white--text text-opacity-80 text-caption d-flex align-center font-weight-medium">
                <v-icon small color="white" class="ml-1 opacity-80">mdi-shopping-outline</v-icon>
                تعداد کل سفارشات: {{ selectedBuyerDetails.orders_count ? persian(selectedBuyerDetails.orders_count) : '۰' }}
              </div>
            </div>
          </v-card>

          <!-- شبکه کارت‌های اطلاعات -->
          <v-row dense>
            <!-- موبایل -->
            <v-col cols="12" sm="6">
              <v-card outlined class="rounded-lg pa-4 d-flex align-start fill-height info-card transition-swing">
                <v-avatar color="blue lighten-5" size="42" class="ml-3 rounded-lg">
                  <v-icon color="blue darken-1">mdi-phone-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text text--darken-1 mb-1">شماره تماس</div>
                  <div class="text-subtitle-1 font-weight-bold" dir="ltr">
                    {{ selectedBuyerDetails.phone ? persian(selectedBuyerDetails.phone) : '---' }}
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- کد پستی -->
            <v-col cols="12" sm="6">
              <v-card outlined class="rounded-lg pa-4 d-flex align-start fill-height info-card transition-swing">
                <v-avatar color="purple lighten-5" size="42" class="ml-3 rounded-lg">
                  <v-icon color="purple darken-1">mdi-mailbox-open-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text text--darken-1 mb-1">کد پستی</div>
                  <div class="text-subtitle-1 font-weight-bold" dir="ltr">
                    {{ selectedBuyerDetails.postal_code ? persian(selectedBuyerDetails.postal_code) : '---' }}
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- استان و شهر -->
            <v-col cols="12">
              <v-card outlined class="rounded-lg pa-4 d-flex align-center info-card transition-swing">
                <v-avatar color="teal lighten-5" size="42" class="ml-3 rounded-lg">
                  <v-icon color="teal darken-1">mdi-map-marker-radius-outline</v-icon>
                </v-avatar>
                <div>
                  <div class="text-caption grey--text text--darken-1 mb-1">استان و شهر</div>
                  <div class="text-subtitle-1 font-weight-bold">
                    <template v-if="selectedBuyerDetails.state && selectedBuyerDetails.state !== '-'">
                      {{ selectedBuyerDetails.state }}
                      <v-icon small color="grey" class="mx-1">mdi-chevron-left</v-icon>
                      {{ selectedBuyerDetails.city || '---' }}
                    </template>
                    <template v-else>نامشخص</template>
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- آدرس دقیق -->
            <v-col cols="12">
              <v-card outlined class="rounded-lg pa-4 d-flex align-start info-card transition-swing">
                <v-avatar color="orange lighten-5" size="42" class="ml-3 rounded-lg mt-1">
                  <v-icon color="orange darken-1">mdi-home-map-marker</v-icon>
                </v-avatar>
                <div class="flex-grow-1">
                  <div class="text-caption grey--text text--darken-1 mb-1">نشانی پستی دقیق</div>
                  <div class="text-body-1 font-weight-medium lh-lg text-justify">
                    {{ selectedBuyerDetails.address || 'آدرسی ثبت نشده است.' }}
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

        </div>
      </v-card>
    </custom-popup>

    <!-- پاپ‌آپ ۲: لیست سفارشات یک خریدار -->
    <custom-popup
      v-model="popups.orders"
      :cons="{ title: 'لیست سفارشات خریدار' }"
      max-width="900"
      :reloadable="false"
    >
      <v-card class="pa-4 rounded-lg" flat>
        <vue-table
          :data="ordersData"
          :headers="orderHeaders"
          :loading="ordersLoading"
        >
              <!-- <template v-slot:filters="{ props, perPage }">
                <v-row no-gutters class="mb-4">
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.length"
                      :items="perPage"
                      class="rounded-lg"
                      dense
                      hide-details
                      :label="$t('qrUsersList.perPage')"
                      outlined
                      @change="() => onPagination(props)"
                    />
                  </v-col>      
                  <v-col class="pa-2" cols="12" lg="3" md="3">
                    <v-text-field
                      v-model="props.search"
                      append-icon="mdi-magnify"
                      label="جستجو ..."
                      outlined
                      dense
                      hide-details
                      clearable
                      class="rounded-lg"
                      @keyup.enter="() => onPagination(props)"
                      @click:clear="() => { props.search = null; onPagination(props); }"
                    />
                  </v-col>
                </v-row>
              </template> -->

          <template v-slot:index="{item}">
            {{ persian(item.index + 1 + ((ordersData.current_page || 1) - 1) * (ordersData.per_page || 10)) }}
          </template>

          <template v-slot:digikala_order_id="{ item }">
            <v-chip small color="grey lighten-4" class="font-weight-bold" dir="ltr">
              {{ item.digikala_order_id }}
            </v-chip>
          </template>

          <template v-slot:items_count="{ item }">
            {{ persian(item.items_count) }}
          </template>

          <template v-slot:order_date="{ item }">
            <div class="d-flex flex-column align-center">
              <div class="d-flex align-center font-weight-medium" dir="ltr">
                <span>{{ persian(item.order_date) }}</span>
                <v-icon small color="primary" class="mr-1">mdi-calendar-check</v-icon>
              </div>
              <span class="text-caption grey--text mt-1">{{ item.created_at_diff }}</span>
            </div>
          </template>

          <!-- دکمه عملیات سفارش (مشاهده اقلام) -->
          <template v-slot:action="{ item }">
            <action-buttons :data="item" :meta="orderMetabutton" />
          </template>
        </vue-table>
      </v-card>
    </custom-popup>

    <!-- پاپ‌آپ ۳: اقلام یک سفارش خاص -->
    <custom-popup
      v-model="popups.items"
      :cons="{ title: 'اقلام سفارش' }"
      max-width="950"
      :reloadable="false"
    >
      <v-card class="pa-4 rounded-lg" flat>
        <vue-table
          :data="itemsData"
          :headers="itemHeaders"
          :loading="itemsLoading"
          :props="itemsTableProps"
          @change="onItemsPagination"

        >
                      <template v-slot:filters="{ props, perPage }">
                <v-row no-gutters class="mb-4">
                  <v-col class="pa-2" cols="12" lg="2" md="3">
                    <v-select
                      v-model="props.length"
                      :items="perPage"
                      class="rounded-lg"
                      dense
                      hide-details
                      :label="$t('qrUsersList.perPage')"
                      outlined
                      @change="() => onPagination(props)"
                    />
                  </v-col>      
                  <v-col class="pa-2" cols="12" lg="3" md="3">
                    <v-text-field
                      v-model="props.search"
                      append-icon="mdi-magnify"
                      label="جستجو ..."
                      outlined
                      dense
                      hide-details
                      clearable
                      class="rounded-lg"
                      @keyup.enter="() => onPagination(props)"
                      @click:clear="() => { props.search = null; onPagination(props); }"
                    />
                  </v-col>
                </v-row>
              </template>

          <template v-slot:index="{item}">
            {{ persian(item.index + 1 + ((itemsData.current_page || 1) - 1) * (itemsData.per_page || 10)) }}
          </template>

          <template v-slot:product="{ item }">
            <div class="d-flex flex-column align-start text-right py-3">
              <div class="font-weight-bold mb-3 text-justify lh-lg text-body-1">{{ item.title || item.product_title || '---' }}</div>
              
              <div class="d-flex flex-wrap align-center gap-2 grey--text text--darken-1 text-caption mt-1">
                <v-chip small outlined color="grey darken-1" class="font-weight-medium" dir="ltr">
                  DKP-{{ item.product_id }}
                </v-chip>
                
                <v-chip v-if="item.variant_id" small outlined color="grey darken-1" class="font-weight-medium" dir="ltr">
                  DKPC-{{ item.variant_id }}
                </v-chip>

                <!-- پشتیبانی از آرایه ویژگی‌ها -->
                <template v-if="item.theme && item.theme.length > 0">
                  <v-chip v-for="(t, index) in item.theme" :key="index" small color="indigo lighten-5" text-color="indigo darken-2" class="font-weight-medium">
                    {{ t.label }}: <span class="font-weight-bold mr-1">{{ t.value }}</span>
                  </v-chip>
                </template>
              </div>
            </div>
          </template>

          <template v-slot:quantity="{ item }">
            <v-avatar color="success lighten-5" size="36">
               <span class="success--text font-weight-bold">{{ persian(item.quantity) }}</span>
            </v-avatar>
          </template>

          <template v-slot:price="{ item }">
            <span class="font-weight-bold text-subtitle-1">{{ formatPrice(item.price) }}</span>
          </template>
        </vue-table>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import ActionButtons from "@/view/components/adapters/qrList/ordersListButton.vue";
import SellerShippingSettings from "./SellerShippingSettings.vue";

export default {
  name: "PurchasesTab",
  components: {
    ActionButtons,SellerShippingSettings
  },
  data: () => ({
    showSetting:false,
    currentBuyerId: null,
    currentOrderId: null,
    loading: false,
    detailsLoading: false,
    ordersLoading: false,
    itemsLoading: false,
    tableProps: { page: 1, limit: 10, search: '', flag: null }, 
    ordersTableProps: { page: 1, limit: 10, search: '' },    
    itemsTableProps: { page: 1, limit: 10, search: '' },
    popups: {
      details: false,
      orders: false,
      items: false,
    },

    tableProps: {
      page: 1,
      length: 10,
    },

    tableData: { data: [], total: 0, current_page: 1, per_page: 10 },
    ordersData: { data: [] },
    itemsData: { data: [] },
    
    selectedBuyerDetails: null,

    buyerHeaders: [
      { value: 'index', text: 'ردیف', sortable: false, align: 'center' },
      { value: 'name', text: 'نام خریدار', sortable: false, align: 'center' },
      { value: 'phone', text: 'موبایل', sortable: false, align: 'center' },
      { value: 'location', text: 'استان/شهر', sortable: false, align: 'center' },
      { value: 'orders_count', text: 'تعداد سفارش', sortable: false, align: 'center' },
      { value: 'action', text: 'عملیات', sortable: false, align: 'center', event: "actions" },
    ],

    orderHeaders: [
      { value: 'index', text: 'ردیف', sortable: false, align: 'center' },
      { value: 'digikala_order_id', text: 'شماره سفارش', sortable: false, align: 'center' },
      { value: 'order_date', text: 'تاریخ و زمان', sortable: false, align: 'center' },
      { value: 'items_count', text: 'تعداد اقلام', sortable: false, align: 'center' },
      { value: 'action', text: 'عملیات', sortable: false, align: 'center', event: "actions" },
    ],

    itemHeaders: [
      { value: 'index', text: 'ردیف', sortable: false, align: 'center' },
      { value: 'product', text: 'مشخصات کالا', sortable: false, align: 'right' },
      { value: 'quantity', text: 'تعداد', sortable: false, align: 'center' },
      { value: 'price', text: 'قیمت (ریال)', sortable: false, align: 'center' },
    ],
  }),

  computed: {
    buyerMetabutton() {
      return {
        buttons: [
          {
            name: "details",
            label: "جزییات خریدار",
            icon: "card-account-details-outline",
            class: "btn-download rounded-pill mb-1",
            action: this.buyerActions,
          },
          {
            name: "orders",
            label: "لیست سفارشات",
            icon: "format-list-bulleted",
            class: "btn-get-code rounded-pill",
            action: this.buyerActions,
          },
        ],
      };
    },
    orderMetabutton() {
      return {
        buttons: [
          {
            name: "items",
            label: "مشاهده اقلام",
            icon: "cart-arrow-down",
            class: "btn-download rounded-pill",
            action: this.orderActions,
          },
        ],
      };
    },
  },

  mounted() {
    this.fetchBuyers();
  },

  methods: {
    settingBuy(){
      this.showSetting= !this.showSetting;

    },
        onPagination(e) {
      if (e && typeof e === 'object' && !Array.isArray(e)) {
        if (
          ('search' in e && e.search !== this.tableProps.search) || 
          ('flag' in e && e.flag !== this.tableProps.flag)
        ) {
          e.page = 1;
        }
        this.tableProps = { ...this.tableProps, ...e };
      }
      this.fetch();
    },
    formatPrice(value) {
      if (!value) return '---';
      return this.persian(Number(value).toLocaleString());
    },

    async fetchBuyers() {
      this.loading = true;
      try {
        const res = await this.$api.get('/v1/digikala/buyer', { params: this.tableProps });
        this.tableData = res.data.data; 
      } catch (error) {
        this.$toast.error("خطا در دریافت لیست خریداران");
      } finally {
        this.loading = false;
      }
    },

    onPagination(e) {
      if (e && typeof e === 'object' && !Array.isArray(e)) {
        this.tableProps = { ...this.tableProps, ...e };
      }
      this.fetchBuyers();
    },

    buyerActions(data, type) {
 if (type === "details") {
        this.getBuyerDetails(data.id);
      } else if (type === "orders") {
        this.currentBuyerId = data.id; 
        this.ordersTableProps.page = 1; 
        this.getBuyerOrders();
      }
    },
 onOrdersPagination(e) {
      if (e && typeof e === 'object' && !Array.isArray(e)) {
        if ('search' in e && e.search !== this.ordersTableProps.search) {
          e.page = 1;
        }
        this.ordersTableProps = { ...this.ordersTableProps, ...e };
      }
      if (this.currentBuyerId) this.getBuyerOrders();
    },
    async getBuyerDetails(id) {
      this.detailsLoading = true;
      this.popups.details = true;
      try {
        const res = await this.$api.get(`/v1/digikala/buyer/${id}`);
        this.selectedBuyerDetails = res.data.data;
      } catch (error) {
        this.$toast.error("خطا در دریافت اطلاعات خریدار");
      } finally {
        this.detailsLoading = false;
      }
    },

 async getBuyerOrders() {
      this.ordersLoading = true;
      this.popups.orders = true;
      try {
        const res = await this.$api.get(`/v1/digikala/buyer/${this.currentBuyerId}/orders`, { 
          params: this.ordersTableProps 
        });
        this.ordersData = res.data.data;
      } catch (error) {
        this.$toast.error("خطا در دریافت سفارشات خریدار");
      } finally {
        this.ordersLoading = false;
      }
    },
  orderActions(data, type) {
      if (type === "items") {
        this.currentOrderId = data.id; 
        this.itemsTableProps.page = 1; 
        this.getOrderItems();
      }
    },

 onItemsPagination(e) {
      if (e && typeof e === 'object' && !Array.isArray(e)) {
        if ('search' in e && e.search !== this.itemsTableProps.search) {
          e.page = 1;
        }
        this.itemsTableProps = { ...this.itemsTableProps, ...e };
      }
      if (this.currentOrderId) this.getOrderItems();
    },

    async getOrderItems() {
      this.itemsLoading = true;
      this.popups.items = true;
      try {
        const res = await this.$api.get(`/v1/digikala/buyer/orders/${this.currentOrderId}/items`, { 
          params: this.itemsTableProps 
        });
        this.itemsData = res.data.data;
      } catch (error) {
        this.$toast.error("خطا در دریافت اقلام سفارش");
      } finally {
        this.itemsLoading = false;
      }
    },  },
};
</script>

<style scoped>
.gap-2 { gap: 8px; }
.lh-lg { line-height: 1.8; }

.info-header-gradient {
  background: linear-gradient(135deg, #011554 0%, #011454ea 100%) !important; 
}
.text-opacity-80 {
  opacity: 0.85;
}

.info-card {
  border-color: #eeeeee !important;
  background-color: #ffffff;
}

.info-card:hover {
  border-color: #2196f3 !important; /* رنگ primary */
  background-color: #f8fbff !important;
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(33, 150, 243, 0.08) !important;
  z-index: 1;
}

.transition-swing {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
